import React, { useState } from 'react';
import { useRecomendaciones } from '../../context/RecomendacionesProvider';
import RecomendacionesFloatingMenu from './RecomendacionesFloatingMenu';
import RecomendacionesModal from './RecomendacionesModal';
import YoutubeModalComponent from '@/components/admin-alineaciones-probables/shared/YoutubeModalComponent';

const RecomendacionesIcon = ({ ...props }) => {
    const { hasRecomendaciones } = useRecomendaciones();
    const [selectedRecomendacion, setSelectedRecomendacion] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [youtubeModalOpen, setYoutubeModalOpen] = useState(false);
    const [youtubeUrl, setYoutubeUrl] = useState('');

    if (!hasRecomendaciones) {
        return null;
    }

    const handleRecomendacionSelect = (recomendacion) => {
        setSelectedRecomendacion(recomendacion);
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
        setSelectedRecomendacion(null);
    };

    const handleYoutubeClick = (url) => {
        setYoutubeUrl(url);
        setYoutubeModalOpen(true);
    };

    const handleCloseYoutubeModal = () => {
        setYoutubeModalOpen(false);
        setYoutubeUrl('');
    };

    return (
        <>
            <RecomendacionesFloatingMenu onRecomendacionSelect={handleRecomendacionSelect} {...props} />

            <RecomendacionesModal
                open={modalOpen}
                onClose={handleCloseModal}
                recomendacion={selectedRecomendacion}
                onYoutubeClick={handleYoutubeClick}
            />

            <YoutubeModalComponent
                youtubeUrl={youtubeUrl}
                open={youtubeModalOpen}
                onClose={handleCloseYoutubeModal}
            />
        </>
    );
};

export default RecomendacionesIcon;
